// Components
import { Typography, Stack } from "@mui/material";

// Styles
import { styles } from "./styles";

const InfoRow = ({
  IconComponent,
  text,
  statusColour = "primary.main",
  boldText = false,
}) => {
  return (
    <Stack direction="row" sx={styles.mainStack}>
      <IconComponent sx={{ fontSize: "1.5rem", color: statusColour }} />
      <Stack direction="row" sx={styles.textStack}>
        <Typography variant="body2" sx={styles.text(boldText)}>
          {text}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default InfoRow;
